import { AttendancePolicyV2Allowance } from '@airreading/common/data';
import { formatAttendancePolicyV2OverviewLines } from '@/lib/attendance-policy-v2-display.js';

interface AttendancePolicyV2OverviewProps {
  policy: AttendancePolicyV2Allowance;
  'data-testid'?: string;
}

export function AttendancePolicyV2Overview({ policy, 'data-testid': dataTestId }: AttendancePolicyV2OverviewProps) {
  const lines = formatAttendancePolicyV2OverviewLines(policy);

  if (lines.length === 0) {
    return (
      <div className="text-sm" data-testid={dataTestId}>
        -
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1 text-sm" data-testid={dataTestId}>
      {lines.map((line, index) => (
        <div key={`${line}-${index}`} data-testid={dataTestId ? `${dataTestId}-line-${index}` : undefined}>
          {line}
        </div>
      ))}
    </div>
  );
}
